/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetYoutubeCapabilitiesQueryResponse, GetYoutubeCapabilitiesPathParams } from "../models/GetYoutubeCapabilities";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getYoutubeCapabilities } from "../axios/getYoutubeCapabilities";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getYoutubeCapabilitiesQueryKey = (station: GetYoutubeCapabilitiesPathParams["station"]) => ["social-export-api", { url: '/youtube/:station/capabilities', params: {station:station} }] as const

export type GetYoutubeCapabilitiesQueryKey = ReturnType<typeof getYoutubeCapabilitiesQueryKey>

export function getYoutubeCapabilitiesQueryOptions(station: GetYoutubeCapabilitiesPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getYoutubeCapabilitiesQueryKey(station)
        return queryOptions<GetYoutubeCapabilitiesQueryResponse, ResponseErrorConfig<Error>, GetYoutubeCapabilitiesQueryResponse, typeof queryKey>({
         enabled: !!(station),
         queryKey,
         queryFn: async ({ signal }) => {
            return getYoutubeCapabilities(station, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns which actions the stored OAuth credentials can perform (upload, delete, add to playlists)
 * @summary Get YouTube connection capabilities for a station
 * {@link /youtube/:station/capabilities}
 */
export function useGetYoutubeCapabilities<TData = GetYoutubeCapabilitiesQueryResponse, TQueryData = GetYoutubeCapabilitiesQueryResponse, TQueryKey extends QueryKey = GetYoutubeCapabilitiesQueryKey>(station: GetYoutubeCapabilitiesPathParams["station"], options: 
{
  query?: Partial<QueryObserverOptions<GetYoutubeCapabilitiesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getYoutubeCapabilitiesQueryKey(station)
         

         const query = useQuery({
          ...getYoutubeCapabilitiesQueryOptions(station, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}